export default __webpack_public_path__ + "static/circoncision-mererue-33ff6231e1e3e761f5486930e47d6965.jpg";